<template>
  <div id="order">
    <div class="pointOut" >您当前需要支付的会员身份</div>
    <div class="main" >
      <div class="status" >
        <span>{{member.name}}</span>
      </div>
      <p v-if="false">有效期：{{dateRange}}</p>
      <div class="pay-det" >
        <div class="title">费用明细</div>
        <div class="pay-list" >
          <p v-for="item in skuList">
            {{item.skuName}}
            <span>¥{{item.shopPrice}}</span></p>
        </div>
        <div class="pay-list" v-if="typeId==1 || typeId==3 || typeId==4">
          <p>
            <span style="float: left;">保险费&nbsp;</span>
            <div style="font-weight: 400; float: left;color: #ed6a0c;background-color: #fffbe8;">
              <van-notice-bar wrapable :scrollable="false" v-html="'投保人需要18周岁以上的成年人'">
              </van-notice-bar>
            </div>
            <span v-if="!insureObj.PayStatic && !needNotInsure">
              <form style="position: absolute;right: 0;top: 0;" id="insureForm" action="https://server.jingcaib.com/bjhockeyRegister" method="post">
                <input type="hidden" name="dd_ShowData" :value="postData">
                <input type="button" value ="购买保险" @click="doSubmitForm" />
              </form>
            </span>
            <span v-else-if="insureObj.PayStatic && insureObj.TotBill">
              （已支付）¥{{insureObj.TotBill}}
            </span>
            <span v-else>
              无需支付
            </span>
            <span v-if="insureObj.PayStatic && insureObj.TotBill">
              <van-button size="small" @click="getInsureOrder">查看保单</van-button>
            </span>
          </p>
        </div>
      </div>
      <div class="sum" >
        应付金额：<span>¥{{this.order.totalPrice}}</span>
      </div>
    </div>
    <div class="pointOut" >选择付款方式</div>
    <van-radio-group v-model="payRadio">
      <van-cell-group>
        <!--<van-cell clickable @click="payRadio = '1'">-->
          <!--<template slot="title" >-->
            <!--<img src="@/assets/images/alipay.png">-->
            <!--<span>支付宝</span>-->
          <!--</template>-->
          <!--<van-radio name="1" />-->
        <!--</van-cell>-->
        <van-cell>
          <template slot="title" >
            <img src="@/assets/images/wechat.png">
            <span>微信</span>
          </template>
          <van-radio name="1" />
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <div class="bottom" >
      <!--<van-checkbox class="checkbox" checked-color="#185494" v-model="checked" >我已阅读并同意协议<span>《协会章程》</span></van-checkbox>-->
      <van-button :class="{ active: checked }" class="submit-btn" size="large" @click="payFor">支付会费</van-button>
      <router-link class="return" to="{ router.go(-1) }" >暂不支付</router-link>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import md5 from 'js-md5'
import { checkPassport } from '@/libs/passport'
import { setMemberType, getOpenId, setOpenId } from '@/libs/cookie-storage'
import { getValidMembership, mapMemberType, isWeiXin, getSearchQueryParams, IsOnPC, varConfig } from '@/utils'
import { getMyMembershipStatus, getMyPlayer, getMyReferee, createMembershipInsuranceOrder, getInsuranceOrder } from '@/api/info'
import { getOrderInfo, getWPUnifiedOrder, getWechatToken, getZhifubao } from '@/api/member'

import { Icon, Button, Toast, Dialog } from 'vant'

Vue.use(Icon).use(Button).use(Dialog)

const appId = varConfig.wxAppId
export default {
  name: 'Order',
  data() {
    return {
      checked: true,
      payRadio: '1',
      validMemberShip: {},
      order: {},
      member: {},
      skuList: [],
      openId: '',
      wechatCode: '',
      postData: '',
      insureObj: {
        TeamNo: '',
        OrderNo: '',
        PolicyNo: '', // xx|xx
        PayStatic: 0, // yes/no
        InsureNo: '',
        InsureTitle: '',
        TotBill: '',
        InsureTime: '',
        Type: '',
        InsureBeginTime: '',
        InsureEndTime: ''
      },
      needNotInsure: false,
      playerInfo: {},
      refereeInfo: {}
    }
  },
  computed: {
    dateRange() {
      return moment(this.validMemberShip.membershipBeginDate).format('YYYY.MM.DD') +
          ' - ' + moment(this.validMemberShip.membershipEndDate).format('YYYY.MM.DD')
    }
  },
  created () {
    this.typeId = parseInt(this.$route.query.type)
    this.member = mapMemberType(this.typeId)
    checkPassport()
    const searchParam = getSearchQueryParams()
    this.wechatCode = searchParam.code
    //  wechat auth pay for it
    if(this.wechatCode) {
      this.order.orderId = this.$route.query.orderId
      this.getWechatToken(this.wechatCode)
      return
    }
    getMyMembershipStatus().then((response) => {
      if (!response) {
          return
      }
      const validMemberShip = this.validMemberShip = getValidMembership(response.data)
      // 判断裁判员是否需要支付保险逻辑
      if ((this.typeId === 3 || this.typeId === 4)) {
        const member = _.find(validMemberShip.membership, function (item) {
          return item.membershipTypeId === 1 && item.status === 2 && item.paymentStatus > 0
        })
        if (member) { // 存在则该状态不需要在二次投保
          this.needNotInsure = true
        }
      }
      // 获取当前的会员保险信息
      const member = _.find(validMemberShip.membership, item => item.membershipTypeId == this.typeId)
      if (member.insurance && member.insurance.OrderNo) {
        this.insureObj = member.insurance
      }
      const params = {
        membershipYear: validMemberShip.year,
        membershipType: this.typeId
      }
      this.getOrderInfo(params)
      // this.getInsureData()
    })
    if (this.typeId === 1) {
      this.getMyPlayer()
    } else if (this.typeId === 3 || this.typeId === 4) {
      this.getMyReferee()
    }
  },
  mounted () {},
  methods: {
    doSubmitForm () {
      var insureForm = document.getElementById('insureForm')
      if ((this.typeId === 1 && this.playerInfo.guardianCertNum) ||
        (this.typeId !== 1 && this.refereeInfo.certificateNum)) {
        // 验证运动员证件号问题
        if (this.typeId === 1 && !this.playerInfo.certificateNum) {
          Dialog.confirm({
            title: '提示',
            message: '被保人信息未填写，请更新被保人证件信息'
          })
        } else {
          insureForm.submit()
        }
      } else {
        Dialog.confirm({
          title: '提示',
          message: '投保人信息未填写，请更新监护人证件信息'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: 'account-protocol', query: {id: 1, reset: 1} })
          })
          .catch(() => {
            // on cancel
          })
      }
    },
    getMyPlayer() {
      getMyPlayer().then(response => {
        const data = response.data
        if (data) {
          const guardians = data.player.guardians
          let obj = {
            guardianId: '',
            guardian: '',
            guardianCertType: '',
            guardianCertNum: '',
            guardianMobile: '',
            guardianRelation: '',
            guardianAddress: ''
          }
          if (guardians && guardians.length > 0) {
            obj = {
              guardianId: guardians[0].id,
              guardian: guardians[0].name,
              guardianCertType: guardians[0].certificateType===1?'身份证':'护照',
              guardianCertNum: guardians[0].certificateNum,
              guardianMobile: guardians[0].mobile,
              guardianRelation: guardians[0].relation,
              // guardianEmail: guardians[0].email,
              guardianAddress: guardians[0].address
            }
          }
          if (data.player.user) {
            delete data.player.user.id
          }
          this.playerInfo = Object.assign(data.player, data.player.user, obj)
          this.playerInfo.membership = data.membership
          this.createMembershipInsuranceOrder(data.membership.id)
        }
      })
    },
    getMyReferee() {
      getMyReferee().then(response => {
        const data = response.data
        if (data) {
          this.refereeInfo = Object.assign({}, data.referee.user, data.referee)
          this.refereeInfo.membership = data.membership
          this.createMembershipInsuranceOrder(data.membership.id)
        }
      })
    },
    createMembershipInsuranceOrder(id) {
      const params = {
        membershipId: id
      }
      createMembershipInsuranceOrder(params).then(response => {
        const data = response.data
        if (data) {
          if (this.typeId === 1) {
            this.playerInfo.insureId = data.insurance.id
            this.getInsureData(this.playerInfo)
          } else if (this.typeId === 3 || this.typeId === 4) {
            this.refereeInfo.insureId = data.insurance.id
            this.getRefereeInsureData(this.refereeInfo)
          }
        }
      })
    },
    getInsureData(playerInfo) {
      /*
      // 保险 裁判员
      const baseInfo = {
        id: 5,
        teamNo: 'bjhHockey',
        beneficiary: '法定',
        BeginTime: null,
        EndTime: null,
        tbMan: {
          Name: '高瑞',
          CardType: '身份证',
          CardNo: '370882198510233735',
          Phone: '15001765115',
          Email: '46657990@qq.com'
        },
        bbManList:[{
          Name: '高瑞',
          CardType: '身份证',
          CardNo: '370882198510233735',
          Sex: '男',
          Birthday: '1985-10-23',
          Phone: ''}]
      } */

      // 保险 运动员
      playerInfo.birthDayStr = ''
      if (playerInfo.birthDay) {
        playerInfo.birthDayStr = playerInfo.birthDay.split('T')
      }
      const baseInfo = {
        id: 5,
        teamNo: playerInfo.insureId,
        type: this.typeId,
        beneficiary: '法定',
        BeginTime: null,
        EndTime: null,
        tbMan: {
          Name: playerInfo.guardian,
          CardType: playerInfo.guardianCertType,
          CardNo: playerInfo.guardianCertNum,
          Phone: playerInfo.guardianMobile,
          Email: playerInfo.email
        },
        bbManList:[{
          Name: playerInfo.trueName,
          CardType: playerInfo.certificateType === 1 ? '身份证' : '护照',
          CardNo: playerInfo.certificateNum,
          Sex: playerInfo.gender,
          Birthday: playerInfo.birthDayStr[0],
          Phone: ''}]
      }
      const timestamp = new Date().getTime()
      const params = {
        timestamp: timestamp,
        digest: md5(timestamp + JSON.stringify(baseInfo) + 'ztSQ_S'),
        baseInfo: baseInfo
      }
      this.postData = JSON.stringify(params)
    },
    getRefereeInsureData(playerInfo) {
      playerInfo.birthDayStr = ''
      if (playerInfo.birthDay) {
        playerInfo.birthDayStr = playerInfo.birthDay.split('T')
      }
      const baseInfo = {
        id: 5,
        teamNo: playerInfo.insureId,
        type: this.typeId,
        beneficiary: '法定',
        BeginTime: null,
        EndTime: null,
        tbMan: {
          Name: playerInfo.trueName,
          CardType: playerInfo.certificateType === 1 ? '身份证' : '护照',
          CardNo: playerInfo.certificateNum,
          Phone: playerInfo.mobile,
          Email: playerInfo.email
        },
        bbManList:[{
          Name: playerInfo.trueName,
          CardType: playerInfo.certificateType === 1 ? '身份证' : '护照',
          CardNo: playerInfo.certificateNum,
          Sex: playerInfo.gender,
          Birthday: playerInfo.birthDayStr[0],
          Phone: ''}]
      }
      const timestamp = new Date().getTime()
      const params = {
        timestamp: timestamp,
        digest: md5(timestamp + JSON.stringify(baseInfo) + 'ztSQ_S'),
        baseInfo: baseInfo
      }
      this.postData = JSON.stringify(params)
    },
    payFor() {
      if (!this.checked || this.order.orderStatus!=0) {
        return
      }
      if ((this.typeId == 1 || this.typeId == 3 || this.typeId == 4) && !this.needNotInsure && !this.insureObj.PayStatic) {
        Toast('请先支付保险费用～')
        return
      }
      // 判断微信内
      if (isWeiXin()) {
        const openId = this.openId = getOpenId()
        if (!openId) { // 获取过openId
          if(!this.wechatCode) {
            this.wechatAuth()
            return
          } else {
            Toast('code过期！')
          }
        } else {
          this.getWPUnifiedOrder()
        }
      } else if (IsOnPC()) { // on PC
        Toast('请在微信端完成支付')
        return
      } else {
        Toast('请在微信端完成支付')
        return
      }
    },
    getOrderInfo(params) {
      getOrderInfo(params).then((res) => {
        const data = res.data
        this.order = data.order || {}
        if(this.order && this.order.sku) {
          this.skuList = this.order.sku
        }
      })
    },
    getAliPay() {
      getZhifubao({}).then((res) => {
        const data = res.data
        const payHtml = data.aliyPayResponse
        const div = document.createElement('div')
        div.innerHTML = payHtml // 将返回的form 放入div
        document.body.appendChild(div)
        document.forms[0].submit()
      })
    },
    getWPUnifiedOrder() {
      let params = {
        orderId: this.order.orderId
      }
      if(this.openId) {
        params.openId = this.openId
        params.tradeType = 'JSAPI'
      }else{
        params.tradeType = 'MWEB'
        Toast('不支持当前支付，请重新发起支付')
        return
      }
      getWPUnifiedOrder(params).then((res) => {
        const data = res.data
        if (data.payInfo && data.payInfo.mwebUrl) {
          const mwebUrl = data.payInfo && data.payInfo.mwebUrl
          const url = this.callbackUrl()
          window.location.href = mwebUrl + '&redirect_url=' + encodeURIComponent(url)
        } else if (data.payInfo && data.payInfo.pkg) {
          this.wechatPay(data.payInfo)
        }
      })
    },
    wechatAuth() {
      const url = window.location.href + '&orderId=' + this.order.orderId
      const currentUrl = encodeURIComponent(url);
      let oauthUrl = "https://open.weixin.qq.com/connect/oauth2/authorize";
      const scopeParam = 'snsapi_base' //snsapi_userinfo
      let params = [
        "appid=" + appId,
        "redirect_uri="+currentUrl,
        "response_type=code",
        "scope="+scopeParam,
        "state=STATE#wechat_redirect"
      ];
      oauthUrl = oauthUrl + "?" + params.join("&");
      window.location.replace(oauthUrl);
    },
    getWechatToken(code) {
      const params = {
        code: code
      }
      getWechatToken(params).then((res) => {
        const data = res.data
        this.openId = data.openId
        setOpenId(data.openId)
        this.getWPUnifiedOrder()
      })
    },
    wechatPay(payInfo) {
      const callbackUrl = this.callbackUrl()
      const payUrl = varConfig.payUrl + "?" + this.queryObjectToString({
          t: Date.now(),
          payInfo: JSON.stringify(payInfo),
          redirectUrl: callbackUrl
        });
      window.location.replace(payUrl)
    },
    callbackUrl() {
      const location = window.location
      const url = location.protocol + '//' + location.host + location.pathname
      return url
    },
    queryObjectToString(params) {
      var ret = [];
      params = params || {};
      for (var key in params) {
        if (params.hasOwnProperty(key)) {
          ret.push(key + "=" + encodeURIComponent(params[key]))
        }
      }
      return ret.join("&")
    },
    getInsureOrder () {
      const params = {
        orderNo: this.insureObj.OrderNo,
        pno: this.insureObj.PolicyNo
      }
      getInsuranceOrder(params).then((res) => {
        const data = res.data
        if (data && data.url) {
          window.location.href = data.url
        }
      })
    }
  }
}
</script>

<style lang="scss" >
#order {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #F8F8F8;
  .pointOut {
    padding: 0 15px;
    height: 40px;
    background-color: rgba(248,248,248,1);
    font-weight:400;
    color:rgba(129,129,129,1);
    line-height: 40px;
  }
  .main {
    padding: 15px;
    background-color: white;
  }
  .status {
    span {
      font-weight:500;
      color:rgba(25,25,25,1);
      font-size: 20px;
    }
  }
  .status+p {
    margin: 0;
    margin-bottom: 10px;
    font-weight:400;
    color:rgba(129,129,129,1);
    font-size: 14px;
    border-bottom: 1px solid rgba(242, 242, 242, 1);
    padding: 10px 0;
    width: 100%;
    padding-right: 15px;
  }
  .pay-det {
    .title {
      margin-top: 12px;
      font-weight:400;
      color:rgba(25,25,25,1);
      font-size:16px;
    }
    .pay-list {
      position: relative;
      p {
        margin: 3px 0;
        font-size:14px;
        font-weight:400;
        color:rgba(129,129,129,1);
        height: 30px;
        line-height: 30px;
        span {
          float: right;
          font-weight:400;
          color:rgba(25,25,25,1);
          font-size:14px;
        }
      }
    }
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(242, 242, 242, 1);
    width: 100%;
    padding-right: 15px;
  }
  .sum {
    font-weight:400;
    color:rgba(25,25,25,1);
    font-size:16px;
    padding: 10px 0;
    span {
      color: #ED5858;
    }
  }
  .van-radio-group {
    .van-cell-group {
      .van-cell {
        padding: 20px;
        font-weight:400;
        color:rgba(129,129,129,1);
        font-size:14px;
        .van-cell__title {
          display: flex;
          align-items: center;
          img {
            height: 31px;
            width: 31px;
            padding-right: 10px;
          }
        }
      }
    }
  }
  .bottom {
    padding-top: 10px;
    background-color: white;
    position: absolute;
    bottom: 0;
    width: 100%;
    .checkbox {
      text-align: center;
      padding-bottom: 10px;
      .van-checkbox__icon {
        display: block;
        margin-bottom: 5px;
      }
      .van-checkbox__icon+span {
        color: #4A4A4A;
        font-size: 14px;
        span {
          color: #185494;
        }
      }
    }
    .submit-btn {
      height:60px;
      background:rgba(245,245,245,1);
      border-radius:2px;
      border: none;
      width: calc(100% - 60px);
      left: 50%;
      transform: translate(-50%, 0);
      font-size:20px;
      font-weight:400;
      color:rgba(129,129,129,1);
    }
    .active {
      background: #185494;
      color: white;
    }
    .return {
      width: calc(100% - 60px);
      height: 60px;
      line-height: 60px;
      display: block;
      text-align: center;
      margin: 0 auto;
      font-size:16px;
      font-weight:400;
      color:rgba(24,84,148,1)
    }
  }

  input[type="button"] {
    -moz-user-select: none;
    background-color: #F5F5F5;
    background-image: -moz-linear-gradient(center top , #F5F5F5, #F1F1F1);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 2px 2px 2px 2px;
    color: #666666;
    cursor: default;
    font-family: arial,sans-serif;
    font-size: 16px;
    font-weight: bold;
    min-width: 54px;
    padding: 8px 8px;
    line-height: 1;
    text-align: center;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/auth/order.vue